<div [formGroup]="form">
   <div class="detail-right-column">
      <ndt-card [title]="'Mailbox Settings'" class="detail-card-half">
         @if (!isSmartVoicemail) {
         <mat-form-field class="flex-full">
            <mat-label>Email Address</mat-label>

            <input
               matInput
               autocomplete="new-password"
               type="text"
               [value]="mailbox?.emailAddress"
               formControlName="emailAddress"
               id="extension-mailbox-emailAddress"
            />

            @if ( form.get('emailAddress')?.hasError('pattern') || form.get('emailAddress')?.hasError('noContent') ) {
            <mat-error> Invalid Email </mat-error>
            }
         </mat-form-field>
         } @if (mailbox) {
         <mat-form-field class="flex-full">
            <mat-label>Operator Extension</mat-label>

            <input
               class="empty-option-placeholder"
               [lcsSingleSelect]="availableExtensionsSelect"
               [accountId]="accountId"
               ndtExtensionSelect
               type="text"
               formControlName="operatorExtension"
               id="mailbox-operator-extension"
               [placeholder]="'Use Account Default - (' + AccountOperatorExtension + ')'"
               [extensionTypesToExclude]="[6, 7]"
            />

            <ndt-extension-select
               #availableExtensionsSelect
               [isIncludeEmptyOption]="true"
               [overrideEmptyOption]="'Use Account Default - (' + AccountOperatorExtension + ')'"
            ></ndt-extension-select>
         </mat-form-field>
         } @if (!isSmartVoicemail) {
         <mat-checkbox
            class="flex-full"
            [checked]="mailbox?.markReadAfterEmail"
            formControlName="markReadAfterEmail"
            id="extension-mailbox-markReadAfterEmail"
         >
            Mark Read After Emailing
         </mat-checkbox>

         <mat-checkbox
            class="flex-full"
            [checked]="mailbox?.discardAudioAfterEmail"
            formControlName="discardAudioAfterEmail"
            id="extension-mailbox-discardAudioAfterEmail"
         >
            Delete Incoming Messages Once Emailed
         </mat-checkbox>

         <mat-checkbox
            class="flex-full"
            [checked]="mailbox?.sayCallerId"
            formControlName="sayCallerId"
            id="extension-mailbox-sayCallerId"
         >
            Say Caller ID
         </mat-checkbox>
         }
      </ndt-card>

      <ndt-card [title]="'Mailbox Prompts'" class="detail-card-half">
         <div class="flex-container flex-half" [class.temporary-greeting-active]="isTemporaryGreetingEnabled()">
            <mat-form-field class="flex-half-drop with-half-button">
               <mat-label>Name</mat-label>

               <input
                  [lcsSingleSelect]="namePromptSelect"
                  [accountId]="accountId"
                  [promptTypesToInclude]="[6]"
                  ndtPromptSelect
                  type="text"
                  formControlName="namePrompt"
                  id="namePrompt"
               />

               <ndt-prompt-select
                  #namePromptSelect
                  [isIncludeEmptyOption]="true"
                  [promptIdsToInclude]="namePromptsToInclude"
               ></ndt-prompt-select>
            </mat-form-field>

            <div class="flex-half-button">
               @if (canAddPrompts()) {
               <button mat-mini-fab color="primary" type="button" (click)="onAddNamePrompt()" class="prompt-button">
                  <mat-icon>add</mat-icon>
               </button>
               }
            </div>
         </div>

         <div class="flex-container flex-half" [class.temporary-greeting-active]="isTemporaryGreetingEnabled()">
            <mat-form-field class="flex-half-drop with-half-button">
               <mat-label>Unavailable</mat-label>

               <input
                  [lcsSingleSelect]="unavailablePromptSelect"
                  [accountId]="accountId"
                  [promptTypesToInclude]="[6]"
                  ndtPromptSelect
                  type="text"
                  formControlName="unavailablePrompt"
                  id="unavailablePrompt"
               />

               <ndt-prompt-select
                  #unavailablePromptSelect
                  [isIncludeEmptyOption]="true"
                  [promptIdsToInclude]="unavailablePromptsToInclude"
               ></ndt-prompt-select>
            </mat-form-field>

            <div class="flex-half-button">
               @if (canAddPrompts()) {
               <button
                  mat-mini-fab
                  color="primary"
                  type="button"
                  (click)="onAddUnavailablePrompt()"
                  class="prompt-button"
               >
                  <mat-icon>add</mat-icon>
               </button>
               }
            </div>
         </div>

         <div class="flex-container flex-half" [class.temporary-greeting-active]="isTemporaryGreetingEnabled()">
            <mat-form-field class="flex-half-drop with-half-button">
               <mat-label>Busy</mat-label>

               <input
                  [lcsSingleSelect]="busyPromptSelect"
                  [accountId]="accountId"
                  [promptTypesToInclude]="[6]"
                  ndtPromptSelect
                  type="text"
                  formControlName="busyPrompt"
                  id="busyPrompt"
               />

               <ndt-prompt-select
                  #busyPromptSelect
                  [isIncludeEmptyOption]="true"
                  [promptIdsToInclude]="busyPromptsToInclude"
               ></ndt-prompt-select>
            </mat-form-field>

            <div class="flex-half-button">
               @if (canAddPrompts()) {
               <button mat-mini-fab color="primary" type="button" (click)="onAddBusyPrompt()" class="prompt-button">
                  <mat-icon>add</mat-icon>
               </button>
               }
            </div>
         </div>

         <mat-checkbox
            class="flex-full"
            [checked]="isTemporaryGreetingEnabled()"
            [disabled]="form.disabled"
            id="mailbox-useTemporaryGreeting"
            (change)="onUseTemporaryGreetingChange($event)"
         >
            Use Temporary Greeting
         </mat-checkbox>

         @if (isTemporaryGreetingEnabled()) {
         <div class="flex-container flex-half">
            <mat-form-field class="flex-half-drop with-half-button">
               <mat-label>Temporary Greeting</mat-label>

               <input
                  [lcsSingleSelect]="temporaryUnavailablePromptSelect"
                  [accountId]="accountId"
                  [promptTypesToInclude]="[6]"
                  ndtPromptSelect
                  type="text"
                  formControlName="temporaryUnavailablePrompt"
                  id="temporaryUnavailablePrompt"
               />

               <ndt-prompt-select
                  #temporaryUnavailablePromptSelect
                  [isIncludeEmptyOption]="true"
                  [promptIdsToInclude]="temporaryUnavailablePromptsToInclude"
               ></ndt-prompt-select>
            </mat-form-field>

            <div class="flex-half-button">
               @if (canAddPrompts()) {
               <button
                  mat-mini-fab
                  color="primary"
                  type="button"
                  (click)="onAddTemporaryUnavailablePrompt()"
                  class="prompt-button"
               >
                  <mat-icon>add</mat-icon>
               </button>
               }
            </div>
         </div>
         }
      </ndt-card>

      @if (!isSmartVoicemail) {
      <div class="messages-container">
         <mat-label>Messages</mat-label>

         <ndt-mailbox-messages-register
            [mailboxMessages]="mailbox?.mailboxMessagesConnection['items']"
            [mailboxId]="mailbox?.mailboxId"
            [disableReset]="disableReset"
            (unreadMessageCountChanged)="unreadMessageCountChanged.emit($event)"
         ></ndt-mailbox-messages-register>
      </div>
      }
   </div>
</div>
